import { put, call, all } from "redux-saga/effects";
import {
  loadLocationsFailed,
  loadLocationsSuccess,
} from "../actions/locationsactions";
import { loadLocations } from "../api/LoadLocations";
import { reportError } from "../actions/erroractions";

export function* locationsSaga(action) {
  const search = action.search;

  if (search === "") {
    yield put(loadLocationsSuccess([]));
  } else {
    try {
      const result = yield call(loadLocations, action);

      if (result.ok) {
        yield put(loadLocationsSuccess(result.locationResults));
      } else {
        yield all([
          put(loadLocationsFailed()),
          put(reportError("Unable to load Locations")),
        ]);
      }
    } catch (e) {
      yield all([
        put(loadLocationsFailed()),
        put(reportError("Unable to load Locations")),
      ]);
    }
  }
}
